navApp.factory 'updateHeight', ['$timeout', 'animateSpeed', '_', ($timeout, animateSpeed, _) ->
  findContainer = (el) -> jQuery(el).parents('.nav-section').eq 0

  (el, className = '', doneFn = ->) ->
    container = findContainer el
    $el = jQuery el
    $el.parents('li').eq(0).addClass 'active'
    $timeout ->
      tallestNavHeight = _.reduce jQuery(container).find('ul:visible, figure:visible'), (memo, obj) ->
        h = jQuery(obj).height()
        if h > memo then h else memo
      , 0

      calloutHeight = $el.parents('.nav-section-container').eq(0).find('figure').eq(0).height()
      bestHeight = Math.max tallestNavHeight, calloutHeight

      container.animate
        height: bestHeight + 32
      , animateSpeed, 'swing', doneFn

    , animateSpeed + 100
]
